import React, { Component } from "react";
import Button from "../Button";
import "./style.css";
import ClickFresh from "../../Animations/ClickFlash";
import PropTypes from "prop-types";
import {
  updateQuestionContentWithouPersistence,
  saveToBackend
} from "../../../Pages/FormBuilderPage/States/actions";
import { connect } from "react-redux";

const UI_WelcomePage = ({
  onQuestionComplete,
  className,
  isInBuilder,
  contents,
  updateQuestionContentWithouPersistence,
  pageNumber,
  saveToBackend
}) => {
  function handleStatementButtonUpdate(e) {
    updateQuestionContentWithouPersistence &&
      updateQuestionContentWithouPersistence(pageNumber, e.target.value);
  }

  function handleButtonEditComplete() {
    saveToBackend && saveToBackend();
  }

  //test agianst empty array for backward compatibility
  //contensts were initiliazed as [""]
  const buttonText =
    contents == null || Array.isArray(contents) ? "Let's Go!" : contents;

  return isInBuilder ? (
    <Button
      editable={true}
      onButtonEditComplete={handleButtonEditComplete}
      onChange={handleStatementButtonUpdate}
      className={"UI_WelcomePage-Button " + className}
      buttonContent={buttonText}
    />
  ) : (
    <ClickFresh
      onClick={() => onQuestionComplete && onQuestionComplete("Continue")}
      composedAnswer={null}
    >
      <Button
        className={
          "UI_WelcomePage-Button UI_WelcomePage-InteractableButton " + className
        }
        buttonContent={buttonText}
      />
    </ClickFresh>
  );
};

UI_WelcomePage.propTypes = {
  onQuestionComplete: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateQuestionContentWithouPersistence: (pageNumber, contents) => {
      dispatch(updateQuestionContentWithouPersistence(pageNumber, contents));
    },
    saveToBackend: () => {
      dispatch(saveToBackend());
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(UI_WelcomePage);
